const UNSAFE = /[\p{Cc}\p{Cf}\p{Zl}\p{Zp}\p{Cs}]/u;

export const SESSION_REASON_PREFIX = "wylo-rc-session-reason:";

export function sessionReasonKey(deviceId: string): string {
  return `${SESSION_REASON_PREFIX}${deviceId}`;
}

export function removeUnsafe(text: string, keepLineBreaks: boolean): string {
  let cleaned = "";
  for (const ch of text.trim()) {
    if (keepLineBreaks && (ch === "\n" || ch === "\r" || ch === "\t")) {
      cleaned += ch;
      continue;
    }
    if (UNSAFE.test(ch)) continue;
    cleaned += ch;
  }
  return cleaned.trim();
}

export function cleanedReason(value: string): string {
  return removeUnsafe(value, true);
}

export function storedSessionReason(deviceId: string, reason: string, launch: string): string {
  return JSON.stringify({ deviceId, reason, launch });
}

export function readStoredSessionReason(
  raw: string | null,
  deviceId: string,
  launch: string | null | undefined,
): string | undefined {
  if (!raw) return undefined;
  let parsed: unknown;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return undefined;
  }
  if (!parsed || typeof parsed !== "object") return undefined;
  const record = parsed as Record<string, unknown>;
  if (record.deviceId !== deviceId) return undefined;
  if (typeof record.reason !== "string") return undefined;
  if (record.reason.length > 1000) return undefined;
  if (typeof record.launch !== "string" || record.launch !== launch) return undefined;
  return record.reason;
}

export function csvCell(value: string): string {
  const prefix = value.length > 0 && "=+-@\t\r".includes(value[0]) ? "'" : "";
  return `"${prefix}${value.replaceAll('"', '""')}"`;
}
